module.exports = __webpack_public_path__ + "img/syukyaku-top-024.6358a566.jpg";